module.exports = [
    { 
        name: 'bms', 
        entry: 'http://localhost:7500/bms/',
        container: '#instance', 
        activeRule: '/bms',
        active: true 
    }, { 
        name: 'saas', 
        entry: 'http://localhost:7500/saas/', 
        container: '#instance', 
        activeRule: '/saas' 
    }
]